import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Scrollbar from '../scrollbar'

import {ReactComponent as Search} from 'images/icons/search.svg'

import Filter from '../filter'

import {
    Container,
    Table as ContainerTable,
    Header,
    HeaderCol,
    Title,
    Actionbar,
    Action,
    Body,
    BodyCol
} from './styled'
import Skeleton from '../skeleton'
import styled from 'styled-components'

const EmptyContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const Table = (props) => {
    const [hasTime, setHasTime] = useState(true)

    const { background, data, action, width, height, margin, boxShadow, filterRight, withoutHeader } = props

    const [filter, setFilter] = useState({
        mode: null,
        option: data.header[0].key
    })

    setTimeout(() => {
        setHasTime(false)
    }, 5000);

    return (
        data && <Container background={background} margin={margin} boxShadow={boxShadow}>
            {!withoutHeader &&
                <Actionbar>
                <Title>
                    {data.title}
                </Title>

                <Action>
                    {props.search && <Search />}
                    {props.filter && <Filter filter={props.filter} />}
                </Action>
            </Actionbar>}
            {data.rows.length > 0
                ? <Scrollbar container={{width: width,height: height,padding: '0 6px 6px 0'}}>
                <ContainerTable>
                    <Header background={background}>
                        <tr>
                            {data.header.map(v =>
                                <HeaderCol key={`header-${v.key}`} color={v.color}>
                                    {v.label}
                                </HeaderCol>
                            )}
                        </tr>
                    </Header>

                    <Body>
                        {data.rows.map((v, i) =>
                            <tr key={i}>
                                {data.header.map(({ key, color }) =>
                                    <BodyCol key={`body-${key}-${i}`} color={color}>
                                        {v[key]}
                                    </BodyCol>
                                )}
                            </tr>
                        )}
                    </Body>
                </ContainerTable>
            </Scrollbar>
            : hasTime
                ? <Skeleton/>
                : <EmptyContainer style={{height: height}}>
                    <span style={{ fontSize: '12px', textAlign: 'center', color: '#212121' }}>
                        {props?.translate?.dash?.noData}
                    </span>
                </EmptyContainer>
            }
        </Container>
    )
}

Table.propTypes = {
    background: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    action: PropTypes.any,
    width: PropTypes.string,
    height: PropTypes.string,
    margin: PropTypes.string,
    boxShadow: PropTypes.bool,
    filterRight: PropTypes.bool,
}

Table.defaultProps = {
    background: null,
    width: 'auto',
    height: 'auto',
    margin: '0',
    boxShadow: false,
    filterRight: false,
    withoutHeader: false
}

export default Table